const internshipSite = [
    {
        img: "intern-site-1",
        title: "Mendelson",
        titel: "Mendelson",
        technologies: "HTML, CSS, JavaScript, Weglot API, Webflow",
        websiteURL: "https://www.mendelson-co.com/"
    },
    {
        img: "intern-site-2",
        title: "Atelier Tobisch",
        titel: "Atelier Tobisch",
        technologies: "Webflow, HTML, CSS, JavaScript",
        websiteURL: "https://www.atelier-tobisch.de/"
    },
    {
        img: "intern-site-3",
        title: "Envy Cafe - Bar",
        titel: "Envy Cafe - Bar",
        technologies: "Webflow, HTML, CSS",
        websiteURL: "https://www.envy-bar.com/"
    }
]

export default internshipSite;